import { DishCategoryType } from '../../../../../store/api/dish-category-api';
import { useDishMenuStore } from '../../../../../store/use-dish-menu-store';
import { getCurrentMenu } from './menu-informer-helpers';

export const findMenuSectionByCategory = (category?: DishCategoryType) => {
  if (!category) return undefined;
  return getCurrentMenu()?.sections?.find((item) => item.id === category.section_id);
};

export const findMenuSectionByCategoryId = (categoryId?: string) => {
  if (!categoryId) return undefined;
  const category = getCurrentMenu()?.categories?.find((item) => String(item.id) === categoryId);
  return findMenuSectionByCategory(category);
};

export const deleteSectionCategory = (categoryId: string) => {
  const menu = getCurrentMenu();
  if (!menu) return;
  const filtered = menu?.sections?.map((item) => ({
    ...item,
    categories: item.categories?.filter((cat) => String(cat.id) !== categoryId),
  }));
  const updatedMenu = { ...menu, sections: filtered };

  useDishMenuStore.setState((prev) => ({
    menu: updatedMenu,
    menuList: prev.menuList?.map((item) => (item.id === updatedMenu.id ? updatedMenu : item)),
  }));
};

export const sortSectionCategories = (sectionId?: number, order?: number[]) => {
  if (!sectionId || !order) return;
  const menu = { ...getCurrentMenu() };
  menu?.sections
    ?.find((item) => item.id === sectionId)
    ?.categories?.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
  useDishMenuStore.setState({ menu });
};

export const updateSectionCategory = (category: DishCategoryType) => {
  const updated = findMenuSectionByCategory(category)?.categories?.map((item) =>
    item.id === category.id ? category : item,
  );

  useDishMenuStore.setState((prev) => ({
    menu: {
      ...prev.menu,
      sections: prev.menu?.sections?.map((item) =>
        item.id === category.section_id
          ? {
              ...item,
              categories: updated,
            }
          : item,
      ),
    },
  }));
};

export const createSectionCategory = (category: DishCategoryType) => {
  const updated = findMenuSectionByCategory(category)?.categories?.splice(0, 0, category);

  useDishMenuStore.setState((prev) => ({
    menu: {
      ...prev.menu,
      sections: prev.menu?.sections?.map((item) =>
        item.id === category.section_id ? { ...item, categories: updated } : item,
      ),
    },
  }));
};
